import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { PageWrapper } from '../components/layout/PageWrapper';
import { OrnamentDivider } from '../components/ui/OrnamentDivider';
import { Seo } from '../components/Seo';

const ROLES = [
  { key: 'citizen', borderColor: 'border-blue-700', emoji: '👤', textColor: 'text-blue-400' },
  { key: 'mafia', borderColor: 'border-mafia-crimson', emoji: '🔫', textColor: 'text-mafia-crimson-light' },
  { key: 'don', borderColor: 'border-mafia-gold', emoji: '🎩', textColor: 'text-mafia-gold' },
  { key: 'sheriff', borderColor: 'border-yellow-600', emoji: '🔍', textColor: 'text-yellow-500' },
];

export function AboutPage() {
  const { t } = useTranslation('home');

  return (
    <PageWrapper>
      <Seo title="О клубе" description="История и цели клуба спортивной мафии Квинсленда. Собираемся каждую субботу в Брисбене." path="/about" />
      {/* Page header */}
      <div className="text-center mb-12">
        <p className="font-mono text-xs text-mafia-gold tracking-[0.3em] uppercase mb-3">◆ Клуб Мафии Квинсленда ◆</p>
        <h1 className="font-display text-5xl md:text-6xl font-bold text-mafia-paper mb-4">
          {t('aboutPage.title')}
        </h1>
        <OrnamentDivider className="mt-8 max-w-xs mx-auto" />
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        {/* Text sections */}
        <div className="space-y-6">
          {[
            { key: 'whatIs', icon: '🃏' },
            { key: 'history', icon: '📜' },
            { key: 'club', icon: '🏛️' },
          ].map(({ key, icon }, i) => (
            <motion.section
              key={key}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              className="card-vintage p-6"
            >
              <div className="flex items-start gap-3">
                <span className="text-2xl mt-0.5">{icon}</span>
                <div>
                  <h2 className="font-display text-lg font-semibold text-mafia-gold mb-2">
                    {t(`aboutPage.${key}.title`)}
                  </h2>
                  <p className="text-mafia-paper-dim leading-relaxed text-sm">
                    {t(`aboutPage.${key}.body`)}
                  </p>
                </div>
              </div>
            </motion.section>
          ))}
        </div>

        {/* Roles */}
        <div>
          <p className="font-mono text-xs text-mafia-gold tracking-[0.2em] uppercase mb-5">
            ◆ Роли в игре
          </p>
          <h2 className="font-display text-2xl font-semibold text-mafia-paper mb-6">
            {t('aboutPage.roles.title')}
          </h2>
          <div className="space-y-3">
            {ROLES.map(({ key, borderColor, emoji, textColor }, i) => (
              <motion.div
                key={key}
                initial={{ opacity: 0, x: 16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.09 }}
                className={`card-vintage border-l-2 ${borderColor} p-4`}
              >
                <h3 className={`font-display font-semibold mb-1 ${textColor}`}>
                  {emoji} {t(`aboutPage.roles.${key}.name`)}
                </h3>
                <p className="text-mafia-paper-dim text-sm leading-relaxed">
                  {t(`aboutPage.roles.${key}.desc`)}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
